var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',[_vm._m(0),_c('section',_vm._l((_vm.clipboard),function(item){return _c('div',{key:item.id},[_vm._v(" "+_vm._s(item)+" ")])}),0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',[_c('h1',[_vm._v("Clipboard")])])
}]

export { render, staticRenderFns }